var map = {
	"./chat.svg": "9e5a",
	"./close.svg": "1d1b",
	"./facebook.svg": "282f",
	"./headphones.svg": "38b2",
	"./info-dark.svg": "476c",
	"./info.svg": "50c1",
	"./instagram.svg": "55b4",
	"./likes.svg": "abb8",
	"./logo-brthrs.svg": "e79b",
	"./logo-ovide.svg": "bde3",
	"./logo-sdc.svg": "5483",
	"./logo-silent-disco.svg": "f498",
	"./mute.svg": "239b",
	"./share.svg": "8096",
	"./speaker.svg": "4d38",
	"./thumbs-up.svg": "c032",
	"./twitter.svg": "b988",
	"./whatsapp.svg": "3776"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";